import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map, Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { TaskTag } from '@tasks/tasks.types';
import { AccountState } from '@state/account/state';

@Injectable({
  providedIn: 'root',
})
export class TaskTagsService {
  private store = inject(Store);
  private httpClient = inject(HttpClient);
  private accountId: number;

  constructor() {
    this.accountId = +this.store.selectSnapshot(AccountState.getAccount)?.id;
  }

  getTaskTags(): Observable<TaskTag[]> {
    const url = `accounts/${this.accountId}/task_sections`;
    return this.httpClient.get<{ task_sections: TaskTag[] }>(url).pipe(
      map((response) => {
        return response.task_sections;
      }),
    );
  }

  updateTaskTag(tag: Partial<TaskTag>): Observable<TaskTag> {
    const url = `accounts/${this.accountId}/task_sections/${tag.id}`;
    const payload = {
      task_section: tag,
    };
    return this.httpClient.put<TaskTag>(url, payload).pipe(
      map((response) => {
        return response;
      }),
    );
  }
}
